<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Kds Routing Plan {{ (kds_routing_plan.name) ? (" - " + kds_routing_plan.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Kds Routing Plan - {{kds_routing_plan.name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Kds Routing Plan - {{kds_routing_plan.name}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="kds_routing_plan.code" :disabled="viewMode" slot-scope="" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="kds_routing_plan.name" :disabled="viewMode" slot-scope="" input-classes="form-control" required/>
                <base-input alternative="" label="Site Id"  input-classes="form-control" > 
                    <p style="text-indent: 5px; font-size: 11px;">(At least one site should be selected)</p>
                     <a-select mode="multiple" v-model="kds_routing_plan.site_ids" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"  :disabled="viewMode">
                         <a-select-option v-for="site in siteList" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                     </a-select>
                </base-input>
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="remark" :disabled="viewMode"/>
                </base-input>
            </div>

             <div class="pt-3 my-3">
                <table class="table table-borderless  table-responsive-md">
                    <thead>
                        <tr>
                            <td scope="col" colspan="2" class="text-center font-weight-bold border ">Routing Plan Details</td>
                        </tr>
                        <tr>
                            <th scope="col" class="border   w-50">Kitchen Category</th>
                            <th scope="col" class="border  w-50">Routing Flow</th>
                        </tr>
                    </thead>
                    <tr v-for="(routingPlanDetails, key) in routingPlanDetailsData" :key="key"
                        class="p-0 m-0">
                        <td class="border  m-0 p-0">
                                <a-select mode="multiple" v-model="routingPlanDetails.category_ids" showSearch placeholder="All Categories" optionFilterProp="children" style="margin: 3px; padding: 1;" :filterOption="filterOption" :disabled="viewMode" input-classes="m-0 rounded-0 border-0 bg-white" >
                                    <a-select-option v-for="category in kitchenCategoryList" :key="category.id" :value="category.id" style="border: 0;">{{category.category_name}}</a-select-option>
                                </a-select>
                        </td>
                        <td class="border  m-0 p-0">
                                <a-select v-model="routingPlanDetails.routing_flow_id" showSearch placeholder="Select Routing Plan Id" optionFilterProp="children" style="margin: 3px; padding: 0;" :filterOption="filterOption" :disabled="viewMode" input-classes="m-0 rounded-0 border-0 bg-white" >
                                    <a-select-option v-for="routing_flow in routingFlowList" :key="routing_flow.id" :value="routing_flow.id">{{routing_flow.route_code}}</a-select-option>
                                </a-select>
                        </td>
                        <td scope="row" 
                            class=" m-0 p-0 border-0"
                             v-if="!viewMode && key == routingPlanDetailsData.length - 1">
                             <i v-if="profileId == 0 && viewMode != true" class="fa fa-times-circle text-danger"
                                style="margin-top: 12px; margin-left: 5px;"
                                 @click.prevent="deleteRoutingPlanDetailRow(key, routingPlanDetails)" > </i>
                             <a-popconfirm
                                v-else
                                title="Are you sure you want to delete this record?" okText="Delete"
                                cancelText="Cancel"
                                @confirm="deleteRoutingPlanDetailRow(key, routingPlanDetails)">
                                    <i class="fa fa-times-circle text-danger" v-if="!viewMode" style="margin-top: 12px; margin-left: 3px;"> </i>
                            </a-popconfirm> 
                        </td>
                    </tr>
                </table>
                    <i class="fa fa-plus-circle text-success " v-if="!viewMode"  @click.prevent="addRoutingPlanDetailRow" ></i>
            </div>



            <br><br>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>

                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'

    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Kitchen Routing Plan?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

            component_x = this

            const sites_data = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites', null, null)
            component_x.siteList = sites_data

            const routing_flow_data = await HTTPRequest.getRequest(this.endPoint + 'kds_routing_flows/get_valid_kds_routing_flows', null, null)
            component_x.routingFlowList = routing_flow_data

            const kitchen_category_data = await HTTPRequest.getRequest(this.endPoint + 'kitchen_categories/get_valid_kitchen_categories', null, null)
            component_x.kitchenCategoryList = kitchen_category_data
            // component_x.kitchenCategoryList.push({id: -1, category_name: ' All Category', category_code: 'all'})

            if (component_x.profileId > 0) {
                var kds_routing_plan_data = await HTTPRequest.getRequest(component_x.endPoint + 'kds_routing_plans/' + component_x.profileId, null)
                if (kds_routing_plan_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (kds_routing_plan_data["error"] == undefined) {
                        component_x.kds_routing_plan = kds_routing_plan_data
                        component_x.remark = kds_routing_plan_data["remark"]
                        let routing_plan_detail_id = component_x.kds_routing_plan.id

                        // 
                        this.kds_routing_plan.site_ids = this.kds_routing_plan.site_ids === -1 ? [] : this.kds_routing_plan.site_ids;



                        // get routing_plan_details
                        this.routingPlanDetailsData =  await HTTPRequest.getRequest(component_x.endPoint + 'kds_routing_plan_details/get_valid_kds_routing_plan_details?routing_plan_id=' + routing_plan_detail_id, null)
                        this.routingPlanDetailsData = this.routingPlanDetailsData.map( detail => {
                            return {
                                id: detail.id,
                                category_ids: detail.category_ids === -1 ? [] : detail.category_ids,
                                routing_flow_id: detail.routing_flow_id,
                                routing_plan_id: detail.routing_plan_id
                                }
                            })
                       

                        console.log('detail')
                        console.log(this.routingPlanDetailsData)
                    } else {
                        this.errors = kds_routing_plan_data["error"].split(",")
                    }
                }
            }
        },
        data: function () {
            return {
                errors: [],
                remark: '',
                customFormMode: 1,
                customForm: {},
                profileData: {},
                kds_routing_plan: {},
                formErrors: [],
                viewMode: this.$attrs.viewMode,
                fetching: false,
                lastFetchId: 0,
                siteList: [],
                routingFlowList: [],
                kitchenCategoryList: [],
                routingPlanDetailsData: [],
                deletedRoutingPlanDetails: [],
            }
        },
        methods: {
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Name', this.kds_routing_plan.name));
                // this.errors.push(ValidateField.required('Site Id', this.kds_routing_plan.site_ids));
                this.errors.push(ValidateField.charMinAndMax('Name', this.kds_routing_plan.name, 0, 30));

                // validates routing plan details table fields
                if(!this.routingPlanDetailsData.length){
                    this.errors.push("Routing Plan Details is required.")
                }
                var field = this.routingPlanDetailsData;
                for (var i = 0, len = field.length; i < len; ++i) {
                    let row = i+1;
                    this.errors.push(ValidateField.required(`Routing Plan - Row ${row}`, this.routingPlanDetailsData[i].routing_flow_id));
                }

                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            getSelectedRoutingCategoryId(value){
                this.kds_routing_plan_detail.category_ids_id = value;
            },
            getSelectedRoutingFlowId(value){
                this.kds_routing_plan_detail.routing_flow_id = value;
            },
            addRoutingPlanDetailRow(){
                // let tableCode = this.getLastTableCode() + 1
                this.routingPlanDetailsData.push({
                    category_ids: [],
                    routing_flow_id: null,
                })
            },
            deleteRoutingPlanDetailRow: async function (index, row){
                console.log(index, row)
                let id = row.id
                if (id) {
                    this.deletedRoutingPlanDetails.push(id)
                }
                let i = this.routingPlanDetailsData.indexOf(row)
                if(i > -1) {
                    this.routingPlanDetailsData.splice(i, 1)
                }
            },
            create: async function () {
                if(!this.validateForm()) {
                    if(this.kds_routing_plan.code) 
                        this.kds_routing_plan.code = this.kds_routing_plan.code.trim()                      
                    this.kds_routing_plan.name = this.kds_routing_plan.name.trim()
                    this.kds_routing_plan.remark = this.remark.trim()
                  
                    this.kds_routing_plan.status = 'A'
                    this.kds_routing_plan.routing_plan_details = this.routingPlanDetailsData
                    var kdsRoutingPlanPayload = { kds_routing_plan: this.kds_routing_plan }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'kds_routing_plans', null, kdsRoutingPlanPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    if(this.kds_routing_plan.code) 
                        this.kds_routing_plan.code = this.kds_routing_plan.code.trim()
                    this.kds_routing_plan.name = this.kds_routing_plan.name.trim()
                    this.kds_routing_plan.remark = this.remark.trim()
                    let status = (this.kds_routing_plan.status == null) ?  "A" : this.kds_routing_plan.status
                    this.kds_routing_plan.status = status
                    this.kds_routing_plan.routing_plan_details = this.routingPlanDetailsData
                    var kdsRoutingPlanPayload = { kds_routing_plan: this.kds_routing_plan }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'kds_routing_plans/' + this.profileId, null, kdsRoutingPlanPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                    // proceed to delete method lenght > 0
                    if (this.deletedRoutingPlanDetails.length){
                        this.delete();
                    }
                }
            },
            delete: async function () {
                let deletedRoutingPlanDetailsPayload = { deleted_routing_plan_details : this.deletedRoutingPlanDetails,
                                            routing_plan_id: this.kds_routing_plan.id }
                var destroy_request = await HTTPRequest.postRequest(this.endPoint + 'kds_routing_plan_details/update_routing_plan_detail_status', null, deletedRoutingPlanDetailsPayload)
                if (destroy_request == undefined) {
                   } else {
                       if (destroy_request["error"] == undefined) {
                       } else {
                           this.errors = destroy_request["error"].split(",")
                       }
                   }
            },
            //  handleStationSearch (value) {
            //     this.fetching = true
            //     this.lastFetchId += 1;
            //     const fetchId = this.lastFetchId;

            //     fetch(this.endPoint + `kds_stations?name=${value}`, {
            //         headers: {
            //         "Content-Type": "application/json",
            //         "Authorization": 'Bearer ' + secureStorage.getItem("accessToken"), 
            //         "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
            //         }
            //     })
            //     .then(res => res.json())
            //     .then(res => {
            //         if (fetchId !== this.lastFetchId) {
            //             return;
            //         }
            //         this.stationList = res.data.map(value => {
            //             return {
            //                 id: value.id,
            //                 station_name: value.station_name,
            //                 disabled: false 
            //             }
            //         })
            //         this.fetching = false
            //     })
            // }
        }
    }
</script>

<style>
</style>